module.exports = __webpack_public_path__ + "static/appInto02-01c6c3a5ab4cf91e8585df1ba08dce26.png";